import { default as index4uEc7PBmCZMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/[[step]]/index.vue?macro=true";
import { default as CreditSwitcherx4CGc27X2hMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/CreditSwitcher.vue?macro=true";
import { default as FlashMessageAccordion4Ti4htdoYJMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/FlashMessageAccordion.vue?macro=true";
import { default as HomeHXlbzTEEviMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/Home.vue?macro=true";
import { default as RatePowerCredit9YvxcISYuuMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/RatePowerCredit.vue?macro=true";
import { default as RatePowerCreditUpgrade0upNHUzJouMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/RatePowerCreditUpgrade.vue?macro=true";
import { default as componentsBXHWTmJeoRMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/components.ts?macro=true";
import { default as eventsnp50QbIisQMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/events.ts?macro=true";
import { default as handlersW4RClEqZ4xMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/handlers.ts?macro=true";
import { default as mapping8wEkS32laIMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/mapping.ts?macro=true";
import { default as propshVL8RCJqP9Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/props.ts?macro=true";
import { default as debugDMQ8wf1uEtMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/debug.ts?macro=true";
import { default as devliT53rgrMyMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/dev.ts?macro=true";
import { default as ppWzqdWfOj8lMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/pp.ts?macro=true";
import { default as deliveryDataL1s5a5RfOvMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/deliveryData.ts?macro=true";
import { default as employerData5o8Qy7WQp7Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/employerData.ts?macro=true";
import { default as privacyDataz8EEqUYkl2Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/privacyData.ts?macro=true";
import { default as creditRedirectE5XbIoXz8vMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/middleware/creditRedirect.ts?macro=true";
import { default as routes7YqS1uKjkzMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/routes.ts?macro=true";
import { default as indexzXbJr2yU2xMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/index.ts?macro=true";
import { default as pricesb2qaAZezO9Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/prices.ts?macro=true";
import { default as redirectsRdVjtmMi25Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/redirects.ts?macro=true";
export default [
  {
    name: "step",
    path: "/:step?",
    meta: index4uEc7PBmCZMeta || {},
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/[[step]]/index.vue")
  },
  {
    name: "components-CreditSwitcher",
    path: "/components/CreditSwitcher",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/CreditSwitcher.vue")
  },
  {
    name: "components-FlashMessageAccordion",
    path: "/components/FlashMessageAccordion",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/FlashMessageAccordion.vue")
  },
  {
    name: "components-Home",
    path: "/components/Home",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/Home.vue")
  },
  {
    name: "components-RatePowerCredit",
    path: "/components/RatePowerCredit",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/RatePowerCredit.vue")
  },
  {
    name: "components-RatePowerCreditUpgrade",
    path: "/components/RatePowerCreditUpgrade",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/components/RatePowerCreditUpgrade.vue")
  },
  {
    name: "config-components",
    path: "/config/components",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/components.ts")
  },
  {
    name: "config-events",
    path: "/config/events",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/events.ts")
  },
  {
    name: "config-handlers",
    path: "/config/handlers",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/handlers.ts")
  },
  {
    name: "config-mapping",
    path: "/config/mapping",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/mapping.ts")
  },
  {
    name: "config-props",
    path: "/config/props",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/config/props.ts")
  },
  {
    name: "data-debug",
    path: "/data/debug",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/debug.ts")
  },
  {
    name: "data-dev",
    path: "/data/dev",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/dev.ts")
  },
  {
    name: "data-pp",
    path: "/data/pp",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/data/pp.ts")
  },
  {
    name: "mappings-deliveryData",
    path: "/mappings/deliveryData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/deliveryData.ts")
  },
  {
    name: "mappings-employerData",
    path: "/mappings/employerData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/employerData.ts")
  },
  {
    name: "mappings-privacyData",
    path: "/mappings/privacyData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/mappings/privacyData.ts")
  },
  {
    name: "middleware-creditRedirect",
    path: "/middleware/creditRedirect",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/middleware/creditRedirect.ts")
  },
  {
    name: "routes",
    path: "/routes",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/routes.ts")
  },
  {
    name: "utils",
    path: "/utils",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/index.ts")
  },
  {
    name: "utils-prices",
    path: "/utils/prices",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/prices.ts")
  },
  {
    name: "utils-redirects",
    path: "/utils/redirects",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/credito/utils/redirects.ts")
  },
  {
    path: "/auto",
    name: "auto"
  },
  {
    path: "/consolidamento",
    name: "consolidamento"
  }
]